import classNames from 'classnames';
import { CountryCode } from 'libphonenumber-js';
import React, { ReactElement } from 'react';
import { Control, FieldValues } from 'react-hook-form';
import { DefaultInputComponentProps } from 'react-phone-number-input';
import PhoneInputWithCountrySelect from 'react-phone-number-input/react-hook-form';

import 'react-phone-number-input/style.css';

import { IAuth } from '@/modules/auth/types';
import { InputField, InputLabel } from '@/shared/components/atoms';
import { ErrorMessage } from '@/shared/components/atoms';
import { IInputFieldProps } from '@/shared/components/atoms/InputField/IInputField';
import FlagComponent from '@/shared/components/atoms/PhoneInputWithCountry/FlagComponent';

import ArrowDown from '~/images/shared/arrows/arrow-up-line.svg';

interface Props {
  defaultCountry?: string;
  control: Control<FieldValues> | Control<IAuth.ILoginSchema>;
  errorMessage?: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  id?: string;
  disabled?: boolean;
  label?: string;
  dir?: 'ltr' | 'rtl';
  className?: string;
  onCountryChange?: (coutry: CountryCode) => void;
}

export default function PhoneInputWithCountry({
  label,
  errorMessage,
  required,
  id,
  disabled,
  placeholder,
  control,
  defaultCountry,
  name,
  dir = 'ltr',
  defaultValue,
  onCountryChange,
  className,
  py,
  textColor,
  borderColor,

  ...rest
}: Props & IInputFieldProps & DefaultInputComponentProps): ReactElement {
  const classNameStyle = classNames(className, py, textColor, borderColor, {
    'rtl:flex rtl:flex-row-reverse': !className,
  });
  return (
    <>
      {label && (
        <InputLabel
          label={label}
          id={id}
          required={required}
          className='inline-block'
        />
      )}
      <PhoneInputWithCountrySelect
        {...rest}
        defaultValue={defaultValue as string}
        international
        className={classNameStyle}
        countryCallingCodeEditable={false}
        defaultCountry={defaultCountry as CountryCode}
        inputComponent={InputField}
        onCountryChange={onCountryChange}
        disabled={disabled}
        numberInputProps={{
          px: '!px-8',
        }}
        flagComponent={(props) => <FlagComponent {...props} />}
        countrySelectProps={{
          arrowComponent: () => (
            <span className='rotate-180 text-primary-default'>
              <ArrowDown width='14' height='8' />
            </span>
          ),
        }}
        name={name}
        dir={dir}
        control={control as Control<FieldValues>}
        placeholder={placeholder}
        required={required}
        aria-invalid={errorMessage ? 'true' : 'false'}
        // error={Boolean(errorMessage)}
      />
      {errorMessage && <ErrorMessage errorMessage={errorMessage || ''} />}
    </>
  );
}
